import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag } from '@pflegenavi/shared/api';

export type CashManagementCapabilityVariant =
  | 'receipt-expense'
  | 'receipt'
  | 'expense';

interface CashManagementCapabilities {
  receiptManagementEnabled: boolean;
  expenseManagementEnabled: boolean;
  /**
   * Translation-key suffix for capability-dependent explanation text.
   * Receipt-only and the (practically unreachable) neither-active case both
   * fall back to the receipt wording.
   */
  variant: CashManagementCapabilityVariant;
}

export const useCashManagementCapabilities = (): CashManagementCapabilities => {
  const receiptManagementEnabled = useFeatureFlagEnabled(
    FeatureFlag.ReceiptManagement
  );
  const expenseManagementEnabled = useFeatureFlagEnabled(
    FeatureFlag.ExpenseManagement
  );

  const variant: CashManagementCapabilityVariant =
    receiptManagementEnabled && expenseManagementEnabled
      ? 'receipt-expense'
      : expenseManagementEnabled
      ? 'expense'
      : 'receipt';

  return { receiptManagementEnabled, expenseManagementEnabled, variant };
};
